import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ShareData } from 'src/lib/fliko/models/users/share.data';
import { Nullish } from 'src/lib/fliko/types/typeish.type';
import { UpdateIdOnly } from 'src/lib/fliko/types/update.type';
import { DatabaseService } from 'src/app/shared/services/database.service';

@Injectable({ providedIn: 'root' })
export class ShareService {
  constructor(private dbSrv: DatabaseService) {}

  /**
   * @path /unitShare/$estateId/
   * @key id
   */
  private get unitShare() {
    return this.dbSrv.estateFactory.getCollection<ShareData>('unitShare/$eId');
  }

  private unitShareByUnit = (unitId: string) =>
    this.dbSrv.estateFactory.getCollectionReadOnly<ShareData>('unitShare/$eId', {
      by: { child: 'unitId' },
      equalTo: unitId
    });

  public getShares$(): Observable<ShareData[]> {
    return this.unitShare.getList();
  }

  public getShare$(id: string): Observable<ShareData | Nullish> {
    return this.unitShare.getElement(id);
  }

  public getSharesByUnitId$(unitId: string): Observable<ShareData[]> {
    return this.unitShareByUnit(unitId).getList();
  }

  public getSharesOnce(): Promise<ShareData[]> {
    return this.unitShare.onceList();
  }

  public setShare(share: ShareData): Promise<void> {
    return this.unitShare.setElement(share.id, share);
  }

  public updateShare(share: UpdateIdOnly<ShareData>): Promise<void> {
    return this.unitShare.updateElement(share.id, share);
  }

  public deleteShare(id: string): Promise<void> {
    // TODO: FLIKO-1346 @Aandrzejmi
    return this.updateShare({ id, shareCount: 0, toDelete: true } as any);
  }
}
